import React from "react";
import LoadingView from "features/EPDSearchModal/components/LoadingView";
import { useTranslation } from "react-i18next";

const LoadMoreIndicator = (props: { open: boolean }) => {
  if (!props.open) return null;
  const { t } = useTranslation();

  return (
    <div className="border-t bottom-0 bg-white z-30 w-full h-[52px] flex justify-center items-center">
      <LoadingView
        className="mr-2 !h-4 !w-4"
        message={t("productSearch.furtherProdcutsAreLoading")}
        containerClassName="!flex-row"
        messageClassName="!mt-0"
      />
    </div>
  );
};

export default LoadMoreIndicator;
